import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SimpleHeader from '../main/headers/simpleHeader';
import HeaderDropdown from '../common/HeaderDropdown';

class SubPageWrapper extends Component {
  static propTypes = {
    page: PropTypes.string,
    pages: PropTypes.arrayOf(PropTypes.object).isRequired,
    dropdown: PropTypes.node,
    getCurrentPage: PropTypes.func, // eslint-disable-line react/require-default-props
    menuItems: PropTypes.object,
  }

  static defaultProps = {
    page: null,
    dropdown: null,
    menuItems: {},
  }

  constructor(props) {
    super(props);
    if (props.getCurrentPage) {
      this.getCurrentPage = props.getCurrentPage.bind(this);
    }
  }

  getCurrentPage() {
    const { page, pages } = this.props;
    return pages[page] || {
      title: '',
      component: null,
    };
  }

  render() {
    const currentPage = this.getCurrentPage();

    return (
      <div>
        <SimpleHeader heading={currentPage.title}>
          {this.props.dropdown || <HeaderDropdown title={currentPage.title} items={this.props.menuItems} />}
        </SimpleHeader>
        {currentPage.component}
      </div>
    );
  }
}

export default SubPageWrapper;
